export default "__VITE_ASSET__iuA8qWSq__"